module.exports = __webpack_public_path__ + "img/btn01.813a50c5.svg";